import { Box, Switch, Typography } from '@material-ui/core';
import { Cake } from '@material-ui/icons';
import React, { useEffect } from 'react';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useCampfireQuery } from '../../../../../global/network/useCampfireQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { GET_CONFIG_ITEM } from '../admin-console-activity-reporting/config-item.gql';
import { GetConfigItem } from '../admin-console-activity-reporting/__generated__/GetConfigItem';

const CONFIG_KEY = 'require-date-of-birth';

export const DateOfBirthForm = () => {
  const { setSnackbar } = useSnackbar();
  const [required, setRequired] = React.useState(true);
  const apiUrl = useApiUrl();
  const campfireMutation = useCampfireFetch({ defer: true });

  const { data, refetch } = useCampfireQuery<GetConfigItem, { key: string }>(GET_CONFIG_ITEM, {
    options: { variables: { key: CONFIG_KEY } },
  });

  useEffect(() => {
    if (!data) return;
    setRequired(data.vm.configItem?.configItemValue?.flagValue ?? data.vm.configItem?.defaultValue ?? true);
  }, [data]);

  const onChange = () => {
    campfireMutation
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: CONFIG_KEY,
          value: !required,
        },
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Request failed');
        }
        setRequired(!required);
        setSnackbar({
          variant: 'success',
          open: true,
          message: 'Settings updated',
        });
        refetch();
      })
      .catch(() => {
        setSnackbar({
          variant: 'error',
          open: true,
          message: 'Unable to update setting',
        });
      });
  };

  return (
    <Box>
      <Typography style={{ fontWeight: 600, fontSize: '16px', display: 'flex', alignItems: 'center' }}>
        <Cake style={{ fontSize: '14px', paddingRight: '5px' }} /> Date of Birth
      </Typography>
      <Typography variant={'body2'} style={{ fontSize: '14px', color: '#808080' }}>
        {'Settings related to collecting date of birth from volunteers'}
      </Typography>
      <Box display='flex' flex='1 1 auto' marginTop='1.5rem'>
        <Box style={{ paddingTop: 4, paddingRight: 8 }}>
          <Switch
            name='require-date-of-birth-toggle'
            color='primary'
            checked={required}
            disabled={campfireMutation.isLoading}
            onChange={onChange}
            inputProps={{ 'aria-label': 'require date of birth toggle' }}
          />
        </Box>
        <Box>
          <Box ml={1}>
            <Typography
              style={{
                fontWeight: 500,
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                color: '#333',
              }}
            >
              Require Date of Birth
            </Typography>
            <Typography style={{ fontSize: '12px', color: '#808080' }}>
              Volunteers must enter their date of birth when setting up and editing their profile. <br />
              When disabled, date of birth is optional. Age-limited tasks are hidden from volunteers without one.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
